import { Typography } from 'antd'
import { subItemsWithFreeAttachment } from 'app/components/Core/LineItem/helpers'

type Props = {
  lineItem: ILineItem
}

const FreeSubItemList = ({ lineItem }: Props) => {
  return (
    <Typography.Text className="text-muted">
      {subItemsWithFreeAttachment(lineItem)
        .map((i) => i.name)
        .join(', ')}
    </Typography.Text>
  )
}

export default FreeSubItemList
